<template>

    <div class="crosshairs">
        <div class="crosshair" v-for="x in 10" :class="`crosshair-${x}`" :key="x" />
    </div>
</template>

<style lang="scss" scoped>
$sectionSecondaryContentRevealDecorationMoveDistance: 25rem;
$sectionSecondaryContentRevealDecorationMoveDuration: 60s;
$sectionSecondaryContentRevealDecoration1Left: 82%;
$sectionSecondaryContentRevealDecoration1Top: 0%;
$sectionSecondaryContentRevealDecoration2Left: 96%;
$sectionSecondaryContentRevealDecoration2Top: 7%;
$sectionSecondaryContentRevealDecoration3Left: 61%;
$sectionSecondaryContentRevealDecoration3Top: 22%;
$sectionSecondaryContentRevealDecoration4Left: 78%;
$sectionSecondaryContentRevealDecoration4Top: 25%;
$sectionSecondaryContentRevealDecoration5Left: 47%;
$sectionSecondaryContentRevealDecoration5Top: 39%;
$sectionSecondaryContentRevealDecoration6Left: 30%;
$sectionSecondaryContentRevealDecoration6Top: 50%;
$sectionSecondaryContentRevealDecoration7Left: 41%;
$sectionSecondaryContentRevealDecoration7Top: 52%;
$sectionSecondaryContentRevealDecoration8Left: 48%;
$sectionSecondaryContentRevealDecoration8Top: 49%;
$sectionSecondaryContentRevealDecoration9Left: 7%;
$sectionSecondaryContentRevealDecoration9Top: 63%;
$sectionSecondaryContentRevealDecoration10Left: 34%;
$sectionSecondaryContentRevealDecoration10Top: 68%;
$sectionSecondaryContentRevealDecoration11Left: 77%;
$sectionSecondaryContentRevealDecoration11Top: 74%;
$sectionSecondaryContentRevealDecoration12Left: 90%;
$sectionSecondaryContentRevealDecoration12Top: 68%;
$sectionSecondaryContentRevealDecoration13Left: 37%;
$sectionSecondaryContentRevealDecoration13Top: 83%;
$sectionSecondaryContentRevealDecoration14Left: 50%;
$sectionSecondaryContentRevealDecoration14Top: 87%;
$sky: #00A3C7;
$sunrise: #F39200;

.crosshairs {
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;

    .crosshair {
        mask-image: url("data:image/svg+xml,%3csvg%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%20575%20575'%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M241.233%20240.547H45.36l-.324.011c-11.802.4-23.146%205.344-31.601%2014.036C4.911%20263.356%200%20275.26%200%20287.823c0%2012.563%204.911%2024.466%2013.435%2033.229%208.455%208.692%2019.8%2013.636%2031.6%2014.036l.325.011h195.873v192.64c0%2012.841%205.132%2024.977%2013.989%2033.776C264.003%20570.24%20275.728%20575%20287.794%20575c12.065%200%2023.791-4.76%2032.572-13.485%208.856-8.799%2013.989-20.935%2013.989-33.776v-192.64H529.64l.324-.011c11.802-.4%2023.146-5.344%2031.601-14.036%208.524-8.763%2013.435-20.666%2013.435-33.229%200-12.563-4.911-24.467-13.435-33.229-8.455-8.692-19.799-13.636-31.601-14.036l-.324-.011H334.355V47.261c0-12.84-5.133-24.977-13.989-33.776C311.585%204.76%20299.859%200%20287.794%200c-12.066%200-23.791%204.76-32.572%2013.485-8.857%208.799-13.989%2020.935-13.989%2033.776v193.286Z'%20fill='%23000'/%3e%3c/svg%3e");
        -webkit-mask-repeat: no-repeat;
        mask-repeat: no-repeat;
        -webkit-mask-size: 100%;
        mask-size: 100%;
        animation-duration: 60s;
        animation-iteration-count: infinite;
        animation-timing-function: linear;
        background: white;
        position: absolute;
        width: 15px;
        height: 15px;

        &.crosshair-1 {
            left: $sectionSecondaryContentRevealDecoration1Left;
            top: $sectionSecondaryContentRevealDecoration1Top;
            animation-name: sectionDecorationMoveBottomLeft
        }

        &.crosshair-2 {
            left: $sectionSecondaryContentRevealDecoration2Left;
            top: $sectionSecondaryContentRevealDecoration2Top;
            background: $sky;
            animation-name: sectionDecorationMoveTopRight
        }

        &.crosshair-3 {
            left: $sectionSecondaryContentRevealDecoration3Left;
            top: $sectionSecondaryContentRevealDecoration3Top;
            background: $sky;
            animation-name: sectionDecorationMoveRight
        }

        &.crosshair-4 {
            left: $sectionSecondaryContentRevealDecoration4Left;
            top: $sectionSecondaryContentRevealDecoration4Top;
            background: $sunrise;
            animation-name: sectionDecorationMoveBottomRight
        }

        &.crosshair-5 {
            left: $sectionSecondaryContentRevealDecoration5Left;
            top: $sectionSecondaryContentRevealDecoration5Top;
            background: $sunrise;
            animation-name: sectionDecorationMoveTopRight
        }

        &.crosshair-6 {
            left: $sectionSecondaryContentRevealDecoration6Left;
            top: $sectionSecondaryContentRevealDecoration6Top;
            animation-name: sectionDecorationArcUpRight
        }

        &.crosshair-7 {
            left: $sectionSecondaryContentRevealDecoration7Left;
            top: $sectionSecondaryContentRevealDecoration7Top;
            animation-name: sectionDecorationArcUpLeft
        }

        &.crosshair-8 {
            left: $sectionSecondaryContentRevealDecoration8Left;
            top: $sectionSecondaryContentRevealDecoration8Top;
            background: $sky;
            animation-name: sectionDecorationMoveBottomRight
        }

        &.crosshair-9 {
            left: $sectionSecondaryContentRevealDecoration9Left;
            top: $sectionSecondaryContentRevealDecoration9Top;
            background: $sunrise;
            animation-name: sectionDecorationMoveTopRight
        }

        &.crosshair-10 {
            left: $sectionSecondaryContentRevealDecoration10Left;
            top: $sectionSecondaryContentRevealDecoration10Top;
            background: $sky;
            animation-name: sectionDecorationMoveTopLeft
        }

    }

}

@keyframes sectionDecorationMoveRight {
    0% {
        transform: translate(0)
    }

    50% {
        transform: translate($sectionSecondaryContentRevealDecorationMoveDistance)
    }

    to {
        transform: translate(0)
    }
}

@keyframes sectionDecorationMoveBottom {
    0% {
        transform: translate(0)
    }

    50% {
        transform: translateY($sectionSecondaryContentRevealDecorationMoveDistance)
    }

    to {
        transform: translate(0)
    }
}

@keyframes sectionDecorationMoveBottomLeft {
    0% {
        transform: translate(0)
    }

    50% {
        transform: translate(calc($sectionSecondaryContentRevealDecorationMoveDistance * -1), $sectionSecondaryContentRevealDecorationMoveDistance)
    }

    to {
        transform: translate(0)
    }
}

@keyframes sectionDecorationMoveBottomRight {
    0% {
        transform: translate(0)
    }

    50% {
        transform: translate($sectionSecondaryContentRevealDecorationMoveDistance, $sectionSecondaryContentRevealDecorationMoveDistance)
    }

    to {
        transform: translate(0)
    }
}

@keyframes sectionDecorationMoveTopLeft {
    0% {
        transform: translate(0)
    }

    50% {
        transform: translate(calc($sectionSecondaryContentRevealDecorationMoveDistance * -1), calc($sectionSecondaryContentRevealDecorationMoveDistance * -1))
    }

    to {
        transform: translate(0)
    }
}

@keyframes sectionDecorationMoveTopRight {
    0% {
        transform: translate(0)
    }

    50% {
        transform: translate($sectionSecondaryContentRevealDecorationMoveDistance, calc($sectionSecondaryContentRevealDecorationMoveDistance * -1))
    }

    to {
        transform: translate(0)
    }
}

@keyframes sectionDecorationArcUpRight {
    0% {
        transform: translate(0)
    }

    25% {
        transform: translate(calc($sectionSecondaryContentRevealDecorationMoveDistance / 2), calc($sectionSecondaryContentRevealDecorationMoveDistance / 2 * -1))
    }

    50% {
        transform: translateY(calc($sectionSecondaryContentRevealDecorationMoveDistance * -1))
    }

    75% {
        transform: translate(calc($sectionSecondaryContentRevealDecorationMoveDistance / 2), calc($sectionSecondaryContentRevealDecorationMoveDistance / 2 * -1))
    }

    to {
        transform: translate(0)
    }
}

@keyframes sectionDecorationArcUpLeft {
    0% {
        transform: translate(0)
    }

    25% {
        transform: translate(calc($sectionSecondaryContentRevealDecorationMoveDistance / 2 * -1), calc($sectionSecondaryContentRevealDecorationMoveDistance / 2 * -1))
    }

    50% {
        transform: translateY(calc($sectionSecondaryContentRevealDecorationMoveDistance * -1))
    }

    75% {
        transform: translate(calc($sectionSecondaryContentRevealDecorationMoveDistance / 2 * -1), calc($sectionSecondaryContentRevealDecorationMoveDistance / 2 * -1))
    }

    to {
        transform: translate(0)
    }
}

</style>
